// extracted by mini-css-extract-plugin
module.exports = {"descriptionDetails":"DescriptionDetails_descriptionDetails__1YGLb bodyS"};